// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-RuvR","right":"styles_right__291t8"};